import { render, staticRenderFns } from "./searchCom.vue?vue&type=template&id=758516a6&scoped=true&"
import script from "./searchCom.vue?vue&type=script&lang=ts&"
export * from "./searchCom.vue?vue&type=script&lang=ts&"
import style0 from "./searchCom.vue?vue&type=style&index=0&id=758516a6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758516a6",
  null
  
)

export default component.exports